import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOverdue = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "overdue-clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_15160",
			"data-name": "Rectangle 15160",
			width: 20,
			height: 20,
			transform: "translate(-0.294 -0.268)",
			fill: "#d9daee",
			stroke: "#7284fa",
			strokeWidth: 1
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "overdue-clip-path-2",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_15162",
			"data-name": "Rectangle 15162",
			width: 13,
			height: 13,
			transform: "translate(-0.174 -0.174)",
			fill: "#d9daee",
			stroke: "#7284fa",
			strokeWidth: 1
		})
	})] }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_14551",
		"data-name": "Group 14551",
		transform: "translate(-336 -476)",
		children: [/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_15198",
			"data-name": "Rectangle 15198",
			width: 50,
			height: 50,
			rx: 25,
			transform: "translate(336 476)",
			fill: "#dae9f7"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_10075",
			"data-name": "Group 10075",
			transform: "translate(110 295)",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					id: "Ellipse_798",
					"data-name": "Ellipse 798",
					transform: "translate(239 194)",
					fill: "#d9daee",
					stroke: "#7284fa",
					strokeWidth: 1,
					children: [/* @__PURE__ */ _jsx("circle", {
						cx: 12,
						cy: 12,
						r: 12,
						stroke: "none"
					}), /* @__PURE__ */ _jsx("circle", {
						cx: 12,
						cy: 12,
						r: 11.5,
						fill: "none"
					})]
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Group_10067",
					"data-name": "Group 10067",
					transform: "translate(241.294 196.268)",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group_10066",
						"data-name": "Group 10066",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group_10065",
							"data-name": "Group 10065",
							clipPath: "url(#overdue-clip-path)",
							children: [/* @__PURE__ */ _jsx("circle", {
								id: "Ellipse_797",
								"data-name": "Ellipse 797",
								cx: 9.576,
								cy: 9.576,
								r: 9.576,
								transform: "translate(0.164 0.164)",
								fill: "#d9daee",
								stroke: "#7284fa",
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeWidth: 1
							}), /* @__PURE__ */ _jsx("path", {
								id: "Path_25531",
								"data-name": "Path 25531",
								d: "M16.5,6.5v4.58l-5,4.58",
								transform: "translate(-6.34 -1.34)",
								fill: "#d9daee",
								stroke: "#7284fa",
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeWidth: 1
							})]
						})
					})
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_10068",
					"data-name": "Group 10068",
					transform: "translate(250.174 205.174)",
					children: [
						/* @__PURE__ */ _jsx("g", {
							id: "Group_10072",
							"data-name": "Group 10072",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_10071",
								"data-name": "Group 10071",
								clipPath: "url(#overdue-clip-path-2)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_25533",
									"data-name": "Path 25533",
									d: "M.5,12.339H12.339L6.42.5Z",
									transform: "translate(-0.007 -0.007)",
									fill: "#d9daee",
									stroke: "#7284fa",
									strokeLinecap: "round",
									strokeLinejoin: "round",
									strokeWidth: 1
								})
							})
						}),
						/* @__PURE__ */ _jsx("line", {
							id: "Line_1058",
							"data-name": "Line 1058",
							y2: 3.453,
							transform: "translate(6.413 5.426)",
							fill: "none",
							stroke: "#7284fa",
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 1
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_10074",
							"data-name": "Group 10074",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_10073",
								"data-name": "Group 10073",
								clipPath: "url(#overdue-clip-path-2)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_25534",
									"data-name": "Path 25534",
									d: "M6.493,10a.493.493,0,1,0,.493.493A.493.493,0,0,0,6.493,10",
									transform: "translate(-0.08 -0.134)",
									fill: "#7284fa"
								})
							})
						})
					]
				})
			]
		})]
	})]
});
export default SvgOverdue;
